import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {surveyQuestionsKey} from "./entities";
import {callGraphQL} from "./api.slice";
const adapter = createEntityAdapter();
const slice = createSlice({
    name: surveyQuestionsKey,
    initialState: adapter.getInitialState({loading: false, errors: null}),
    reducers: {},
    extraReducers: {
        [callGraphQL.fulfilled]: (state, {payload}) => {
            if (payload[surveyQuestionsKey]) adapter.upsertMany(state, payload[surveyQuestionsKey]);
        }
    }
})
export default slice.reducer;
export const selectSurveyQuestions = state => state[surveyQuestionsKey]
export const {
    selectById: surveyQuestionById,
    selectIds: surveyQuestionIds,
    selectEntities: surveyQuestionEntities,
    selectAll: allSurveyQuestions,
    selectTotal: surveyQuestionsCount
} = adapter.getSelectors(selectSurveyQuestions)
